import { styled } from '@mui/material';
import { Button, Box, Typography, Stack } from '@customink/pigment-react';
import { ReactElement } from 'react';
import { EmptyFunction } from '~/adapters/typescript/emptyFunction';
import { MasterCard } from '~/components/Icon/braintree/MasterCard';
import { Visa } from '~/components/Icon/braintree/Visa';
import { Jcb } from '~/components/Icon/braintree/Jcb';
import { UnionPay } from '~/components/Icon/braintree/UnionPay';
import { Discover } from '~/components/Icon/braintree/Discovery';
import { AmericanExpress } from '~/components/Icon/braintree/AmericanExpress';
import { Maestro } from '~/components/Icon/braintree/Maestro';

const CardTypeToIcon: Record<string, ReactElement> = {
    MasterCard: <MasterCard />,
    Visa: <Visa />,
    JCB: <Jcb />,
    UnionPay: <UnionPay />,
    Discover: <Discover />,
    Maestro: <Maestro />,
    'American Express': <AmericanExpress />,
};

const StyledCardRow = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
    borderRadius: theme.shape.borderRadius,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
}));

interface CardRowProps {
    cardType: string;
    lastFour: string;
    onRemove: EmptyFunction;
}

export function CardRow({ cardType, lastFour, onRemove }: CardRowProps) {
    return (
        <StyledCardRow>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {CardTypeToIcon[cardType] ?? null}
                <Typography>
                    {cardType} ending in **{lastFour}
                </Typography>
            </Box>
            <Button variant="link" onClick={onRemove}>
                Remove
            </Button>
        </StyledCardRow>
    );
}
